import {
  put,
  fork,
  call,
  takeEvery,
  takeLatest,
  all,
  select,
} from 'redux-saga/effects';
import app from '../../app';
import {
  loadTeamMemberListCompletion,
  loadTeamMemberDetailCompletion,
} from '../../actions';

function* watchLoadTeamMemberList() {
  yield takeLatest('LOAD_TEAM_MEMBER_LIST', function*({ willReload }) {
    const {
      list,
      query: { size, tab, sub, sort, time, isTeam, level },
    } = yield select(state => state.member.team.master);

    let start = 0;
    if (!willReload && list) {
      start = list.length;
    }

    let submitTab = '',
      submitSort = '';

    if (sort === 0) {
      submitSort = 'A';
    } else if (sort === 1) {
      submitSort = 'D';
    }

    if (tab === 'spend') {
      submitTab = 'B';
    } else if (tab === 'retail') {
      submitTab = 'E';
    } else if (tab === 'reward') {
      submitTab = 'R';
    } else if (tab === 'teamInfo') {
      if (sub === 2) {
        submitTab = 'T';
      } else if (sub === 1) {
        submitTab = 'O';
      } else {
        submitTab = 'S';
      }
    } else if (tab === 'upgradeBai' || tab === 'upgradeZuan') {
      if (sub === 1) {
        submitTab = 'C';
      } else {
        submitTab = 'S';
      }
    }

    if (tab === 'teamInfo' || tab === 'upgradeBai' || tab === 'upgradeZuan') {
      if (!submitSort) {
        submitSort = 'D';
      }
    }

    const options = {
      url: `/api/stat/list`,
      data: {
        start,
        size,
        sort: `${submitTab}${submitSort}`,
        time: time ? new Date(time).getTime() / 1000 : undefined,
        isTeam: isTeam || undefined,
        level: level || undefined,
      },
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadTeamMemberListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

function* watchLoadTeamMemberDetail() {
  yield takeEvery('LOAD_TEAM_MEMBER_DETAIL', function*({ uid, time }) {
    const options = {
      url: `/api/stat/user`,
      data: { uid, time: time ? new Date(time).getTime() / 1000 : undefined },
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadTeamMemberDetailCompletion(uid, result.error, result.data));
  });
}

export default function* teamSaga() {
  yield all([fork(watchLoadTeamMemberList), fork(watchLoadTeamMemberDetail)]);
}
